import React from 'react';
import { ToggleWrapper } from "./ToggleWrapper";
import { ToggledFeature } from "./featureToggleService";
import { useAuthorizationChecker } from "authorization-scope";
import { TeamPermission } from "nekst-api";

export function ManageCommissionAndClosingDateWrapper(
  props: React.PropsWithChildren
) {
  const { isGranted } = useAuthorizationChecker();

  if (isGranted(TeamPermission.MANAGE_PROJECT_DETAILS_FIELDS)) {
    return (
      <ToggleWrapper feature={ToggledFeature.MANAGE_COMMISSION_AND_CLOSING_DATES}>
        {props.children}
      </ToggleWrapper>
    );
  } else {
    return null;
  }
}
